<template>
  <div>
    <v-dialog v-model="dialog" fullscreen>
      <v-card v-if="dialog">
        <v-card-title>Satın Alma Siparişi
        </v-card-title>
        <v-expansion-panels flat hover>
          <v-expansion-panel>
            <v-expansion-panel-header class="bg-light">Tedarikçi ve Depo Seçimi</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <div class="col-4">
                  <v-text-field
                      v-model="searchText"
                      append-icon="mdi-magnify"
                      label="Ara"
                      dense
                      solo
                      single-line
                      hide-details
                      size="small"
                      class="m-1"
                      filled
                      rounded
                  ></v-text-field>
                </div>
                <v-data-table
                    :loading="pendingOrdersSuppliersLoading"
                    :headers="pendingOrdersSuppliersHeaders"
                    :items="pendingOrdersSuppliers"
                    :items-per-page="perPage"
                    item-key="code"
                    class="elevation-1"
                    hide-default-footer
                    :search="searchText"
                    :no-data-text="searchText.length >= 3 ? `${noPendingOrdersSuppliersMessage}` : 'Arama yapın'"
                >
                  <template v-slot:item.selection="{ item }">
                    <v-checkbox
                        v-model="selectedCode"
                        @click="selectCode(item)"
                        :on-icon="'mdi-checkbox-marked'"
                        :off-icon="'mdi-checkbox-blank-outline'"
                        :true-value="item"
                        :false-value="false"
                        color="warning"
                    >
                    </v-checkbox>
                  </template>
                </v-data-table>
                <div class="d-flex row mt-10 align-items-center">
                  <div class="col-2">
                <h3 class="mt-1">Depo Seçimi</h3>
                  </div>
                  <div class="col-4">
                  <v-select
                      hide-details
                      v-model="userWarehouseCodeVal"
                      label="Depo"
                      placeholder="Depo Seçiniz"
                      clearable
                      filled
                      dense
                      solo
                      :items="erpWarehouseList"
                      :item-text="item => item.name"
                      :item-value="item => item.code"
                  >
                  </v-select>
                  </div>
                </div>
              </v-card-text>
<!--              <div class="col-lg-4">-->
<!--                <search-select-->
<!--                    :search-type="'supplier'"-->
<!--                    @itemChange="(e) => (selectCode(e))"-->
<!--                    :placeholder="'Tedarikçiler'"-->
<!--                >-->
<!--                </search-select>-->
<!--              </div>-->
          </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mt-5">
            <v-expansion-panel-header class="bg-light">Ürün Listesi</v-expansion-panel-header>
            <v-expansion-panel-content>
              <Results></Results>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="mt-5">
            <v-expansion-panel-header class="bg-light">Sipariş Özeti</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="mt-2"><span class="fs-4 fw-semibold">Tedarikçi :</span> <span class="fs-3" v-if="selectedCode">{{selectedCode?.code}} -- {{selectedCode?.name}}</span></p>
              <v-data-table
                  hide-default-footer
                  no-data-text="Sepetinizde ürün bulunmamaktadır."
                  :items="pendingOrdersCartView"
                  :headers="pendingOrdersCartHeaders"
              >
                <template v-slot:item.amount="{ item }">
                <span class="font-weight-semibold">
                  {{ numberConverter(item.amount) }}
                  </span>
                </template>
                <template v-slot:item.unitPrice="{ item }">
                <span class="font-weight-semibold">
                  {{ numberConverter(item.unitPrice) }}
                  </span>
                </template>
              </v-data-table>

              <v-textarea class="col-lg-4 mt-5" solo dense placeholder="Sipariş Açıklaması" v-model="orderDescription"></v-textarea>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="submitOrder" color="success darken-1" style="color: white;" :loading="loading">
            Siparişi Oluştur
          </v-btn>

          <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
            KAPAT
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
// import SearchSelect from "@/components/searchSelect.vue";

import Results from "@/components/orders/PurchaseOrders/dialogs/PurchaseOrderResult/Results.vue"
import {numberConverter} from "../../../../../helpers";
import {swalToast} from "@/helpers/swalToast";
export default {
  name: "PurchaseOrderDialog",
  components: {
    // SearchSelect,
    Results,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
      selectedCode: null,
      perPage: 10,
      currentPage: 1,
      searchText: "",
      loading: false,
      pendingOrdersCartHeaders: [
          {
        value: "stockCode",
        text: "Stok Kodu",
          },
        {
          value: "stockName",
          text: "Stok Adı",
        },
        {
          value: "unitPrice",
          text: "Birim Fiyat",
        },
        {
          value: "quantity",
          text: "Sipariş Miktarı",
        },
        {
          value: "unit",
          text: "Birim",
        },
        {
          value: "amount",
          text: "Tutar",
        }

      ],
      orderDescription: "",
      userWarehouseCodeVal: null,
    }
  },
  computed: {
    ...mapState("order", ["pendingOrdersSuppliers", "pendingOrdersSuppliersHeaders", "pendingOrdersSuppliersLoading","pendingOrdersCart","pendingOrdersCartView","noPendingOrdersSuppliersMessage"]),
    ...mapState("stock",["stockList","stockListMetaData","stockListHeaders","stockListLoading"]),
    ...mapState("auth",["user"]),
    ...mapState("company", ['erpWarehouseList']),
  },
  methods: {
    numberConverter,
    ...mapActions("order",["getPendingOrdersSupplier","addPurchaseOrder"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapActions("company", ['fetchErpWarehouseList']),
    ...mapMutations("company", ['setErpWarehouseList']),
    ...mapMutations("order", ['setPendingOrdersCart',"setPendingOrdersSuppliers","setPendingOrdersCartView"]),
    async _fetchSupplierList() {
      await this.getPendingOrdersSupplier({
        params:{
          searchText: this.searchText
        },
        body: {},
      })
    },
    async selectCode (value) {
      this.selectedCode = value;
    },
    async submitOrder() {
      if (!this.selectedCode) {
        await swalToast.fire({
          icon: 'error',
          text: "Lütfen tedarikçi seçiniz",
          iconColor: 'danger',
        });
        return;
      }
      if (!this.userWarehouseCodeVal || this.userWarehouseCodeVal === -1) {
        await swalToast.fire({
          icon: 'error',
          text: "Lütfen bir depo seçiniz",
          iconColor: 'danger',
        });
        return;
      }
      if (this.pendingOrdersCart.length === 0) {
        await swalToast.fire({
          icon: 'error',
          text: "Lütfen bir sepete ürün ekleyiniz",
          iconColor: 'danger',
        });
        return;
      }
      let params = {
        salesPersonCode: this.user.SalesPersonCode
      };
      let orderBody = {
        purchaseOrder: {
          description: this.orderDescription,
          supplierCode: this.selectedCode.code,
          warehouseCode: this.userWarehouseCodeVal,
        },
        purchaseOrderItems: this.pendingOrdersCart
      };
      this.loading = true;
      let result = await this.addPurchaseOrder({
        params: params,
        body: orderBody
      });
      if (result) {
        this.searchText = "";
        this.selectedCode = null;
        this.userWarehouseCodeVal = null;
        this.orderDescription = "";
        this.setPendingOrdersCart([]);
        this.setPendingOrdersCartView([]);
        this.setPendingOrdersSuppliers([]);
      }
      this.loading = false;
      await this.$parent._fetchPurchaseOrders();
    },
    async _fetchErpWarehouseList() {
      await this.fetchErpWarehouseList({
        params: {},
        body: {}
      });
      let tempWarehouseList = this.erpWarehouseList.slice();
      tempWarehouseList.unshift({code: -1, name: 'Depo Seçin'})
      this.setErpWarehouseList(tempWarehouseList);
    },
  },
  mounted() {
    this._fetchErpWarehouseList();
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
    "searchText": function (newVal) {
      this.searchText = newVal;
      if (newVal.length >= 3)
        this._fetchSupplierList();
    },
  }
}
</script>

<style scoped>

</style>